import { render } from "./WebhooksSidebar.vue?vue&type=template&id=10e260d2&ts=true"
import script from "./WebhooksSidebar.vue?vue&type=script&lang=ts"
export * from "./WebhooksSidebar.vue?vue&type=script&lang=ts"

import "./WebhooksSidebar.vue?vue&type=style&index=0&id=10e260d2&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__